(function () {
  if (window.__halterungEinordnung) return;
  window.__halterungEinordnung = true;

  var KEY = '3idee_auswahl';
  var cache = {};

  function auswahl() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; }
  }
  function proxy() { return (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db'; }
  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }
  function monitorDaten(ref) {
    if (!cache[ref]) {
      cache[ref] = abruf(proxy() + '/monitors/' + encodeURIComponent(ref)).then(function (j) {
        var d = (j && j.ok && j.data) || {};
        return { zoll: Number(d.size_inch) || 0, kg: (Number(d.weight_g) || 0) / 1000 };
      }).catch(function () { return { zoll: 0, kg: 0 }; });
    }
    return cache[ref];
  }
  function spanne(s) {
    var p = String(s || '').split(',');
    if (p.length !== 2) return null;
    var a = parseFloat(p[0]), b = parseFloat(p[1]);
    return isNaN(a) || isNaN(b) ? null : [a, b];
  }
  function urteil(el, m) {
    var z = spanne(el.getAttribute('data-z')), k = spanne(el.getAttribute('data-kg'));
    if (!m || (!m.zoll && !m.kg)) return '';
    if (m.zoll && z) {
      if (m.zoll > z[1] + 0.4) return 'gross';
      if (m.zoll < z[0] - 0.4) return 'klein';
    }
    if (m.kg && k) {
      if (m.kg > k[1]) return 'schwer';
      if (m.kg < k[0]) return 'leicht';
    }
    return 'ok';
  }
  function urteilMit(el, m, stand) {
    var lokal = urteil(el, m);
    var f = window.SetupUrteil && stand ? window.SetupUrteil.fuer(stand, el.getAttribute('data-skus')) : null;
    if (!f || f.urteil === 'ausfall') return lokal;
    if (f.urteil === 'sonder' || f.urteil === 'offen') return '';
    if (f.urteil === 'traegt') return f.requires.length ? 'platte' : 'ok';
    return lokal && lokal !== 'ok' ? lokal : 'nein';
  }
  function zahl(v, e) { return String(Math.round(v * 10) / 10).replace('.', ',') + e; }
  function weitere(el, n) {
    var t = el.getAttribute('data-t-weitere') || '+ {{ n }}';
    return t.replace(/\{\{\s*n\s*\}\}/, n);
  }

  function zeichnen(m, a, stand) {
    var name = a.name || (a.namen && a.namen[0]) || '';
    var mehr = (a.anzahl || (a.refs || []).length || 1) - 1;

    document.querySelectorAll('[data-eo]').forEach(function (eo) {
      var leer = eo.querySelector('[data-eo-leer]'), voll = eo.querySelector('[data-eo-voll]');
      if (leer) leer.hidden = !!m;
      if (voll) voll.hidden = !m;
      if (m) {
        var n = eo.querySelector('[data-eo-name]');
        if (n) n.textContent = name + (mehr > 0 ? ' ' + weitere(eo, mehr) : '');
        var w = eo.querySelector('[data-eo-werte]');
        if (w) w.textContent = [m.zoll ? zahl(m.zoll, '″') : '', m.kg ? zahl(m.kg, ' kg') : ''].filter(Boolean).join(' · ');
      }
      var zmin = Number(eo.getAttribute('data-zmin')) || 10, zmax = Number(eo.getAttribute('data-zmax')) || 60;
      var kmax = Number(eo.getAttribute('data-kmax')) || 30;
      eo.classList.toggle('eo--mit', !!m);
      eo.querySelectorAll('[data-eo-z]').forEach(function (z) {
        var u = urteilMit(z, m, stand);
        z.setAttribute('data-urteil', u);
        var s = z.querySelector('[data-eo-s]');
        if (s) s.textContent = u ? (eo.getAttribute('data-t-' + u) || '') : '';
        z.querySelectorAll('[data-eo-spalte]').forEach(function (sp) {
          var mk = sp.querySelector('[data-eo-m]');
          if (!mk) return;
          var istZ = sp.getAttribute('data-eo-spalte') === 'z';
          var v = m ? (istZ ? m.zoll : m.kg) : 0;
          mk.hidden = !v;
          if (!v) return;
          var p = istZ ? (v - zmin) / (zmax - zmin) * 100 : v / kmax * 100;
          mk.style.left = Math.max(0, Math.min(100, p)) + '%';
        });
      });
    });

    document.querySelectorAll('[data-hep]').forEach(function (h) {
      var leer = h.querySelector('[data-hep-leer]'), voll = h.querySelector('[data-hep-voll]');
      if (leer) leer.hidden = !!m;
      if (voll) voll.hidden = !m;
      if (!m) return;
      var n = h.querySelector('[data-hep-name]');
      if (n) n.textContent = name;
      var mh = h.querySelector('[data-hep-mehr]');
      if (mh) { mh.hidden = mehr < 1; mh.textContent = mehr > 0 ? weitere(h, mehr) : ''; }
      var u = urteilMit(h, m, stand);
      var f = window.SetupUrteil && stand ? window.SetupUrteil.fuer(stand, h.getAttribute('data-skus')) : null;
      var fall = f ? f.urteil : '';
      var nurSonder = h.hasAttribute('data-hep-nur-sonder');
      var ok = h.querySelector('[data-hep-ok]'), nein = h.querySelector('[data-hep-nein]');
      if (ok) {
        ok.hidden = nurSonder || fall !== 'traegt';
        var ot = ok.querySelector('[data-hep-ok-text]');
        var nRef = (a.refs || []).length || 1;
        if (ot && !ok.hidden) ot.textContent = nRef > 1
          ? (ok.getAttribute('data-t-mehr') || '').replace('%n%', nRef)
          : (ok.getAttribute('data-t-eins') || '').replace('%name%', name);
      }
      if (nein) nein.hidden = nurSonder || !u || u === 'ok' || u === 'platte';
      var so = h.querySelector('[data-hep-sonder]'), of = h.querySelector('[data-hep-offen]');
      if (so) so.hidden = fall !== 'sonder';
      if (of) of.hidden = fall !== 'offen';
      var au = h.querySelector('[data-hep-ausfall]');
      if (au) au.hidden = !(stand && stand.ausfall);
      if (window.SetupUrteil) h.querySelectorAll('[data-hep-finder]').forEach(function (l) {
        if (!l.__weg) { l.__weg = true; l.href = window.SetupUrteil.finderWeg(l.getAttribute('href')); }
      });
    });
  }

  function lauf() {
    var a = auswahl();
    var refs = (a.refs || []).map(String);
    if (!refs.length) { zeichnen(null, a); return; }
    var urteilHolen = window.SetupUrteil ? window.SetupUrteil.hole() : Promise.resolve(null);
    Promise.all([Promise.all(refs.map(monitorDaten)), urteilHolen.catch(function () { return null; })]).then(function (b) {
      var liste = b[0], stand = b[1];
      var m = { zoll: 0, kg: 0 };
      liste.forEach(function (x) { m.zoll = Math.max(m.zoll, x.zoll); m.kg = Math.max(m.kg, x.kg); });
      zeichnen(m.zoll || m.kg || stand ? m : null, a, stand);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lauf);
  else lauf();
  document.addEventListener('finder:auswahl', lauf);
  window.addEventListener('storage', function (e) { if (e.key === KEY) lauf(); });
})();
